import React from 'react';
import './LeftBar.scss';

interface LeftBarProps {
  [key: string]: any;
}

export const LeftBar = (props: LeftBarProps) => {
  const { } = props;
  return (
    <div className='left-bar'>
    </div>
  );
}
